import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserClass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13.9 5.6c-1.4 0-2.7.3-3.8.9v1.7c0 1.3-1.6 2.3-3.7 2.4-.4 1-.6 2-.6 3.2 0 4.5 3.6 8.2 8.2 8.2s8.1-3.6 8.2-8.2c0-4.6-3.6-8.2-8.2-8.2Zm-.1 2.3c1.9 0 3.6 1.6 3.6 3.5s-1.5 3.5-3.5 3.6c-1.9 0-3.5-1.6-3.6-3.5 0-1.9 1.6-3.5 3.5-3.6m5.7 10c-.4.6-1 1.1-1.6 1.6-.7.5-1.5.9-2.4 1.1-.6.2-1.1.2-1.8.2-1.7 0-3.1-.6-4.5-1.6-.5-.4-.8-.8-1.2-1.3v-.1c.1-.8.3-1.5.8-2.2.4-.6.9-1 1.6-1.1h.2c.5.5 1 .9 1.7 1.1.7.3 1.5.3 2.2.2q1.35-.3 2.4-1.2s.1-.1.2 0c.7.1 1.2.5 1.6 1.1.4.7.7 1.5.8 2.3v.1Z" />
    <path d="m2 5 3.5 1.4c.2 0 .3.1.5.1s.4 0 .5-.1l4.1-1.7c.2 0 .2-.2.2-.4s0-.3-.2-.4L6.5 2.2c-.2 0-.3-.1-.5-.1s-.4 0-.5.1L1.4 3.9c-.2 0-.2.2-.2.4v5c0 .2.2.4.4.4s.4-.2.4-.4V4.9Zm.8 1.2v2c0 .9 1.4 1.6 3.2 1.6s3.2-.7 3.2-1.6v-2l-2.4 1c-.3.1-.5.2-.8.2s-.6 0-.8-.2z" />
  </svg>
);
export default SvgUserClass;
